module.exports = __webpack_public_path__ + "static/ga_integration_3-f99d0e9679443bbcf82526fa67145c68.png";